class ProfileData {
    gender: string;
    firstname: string;
    lastname: string;
    address: string;
    city: string;
    postalcode: string;
    phone: string;
}

class CompanyData {
    name: string;
    siret: string;
    vatNumber: string;
}

export class UserProfile {
    readonly _id: string;
    readonly email: string;
    readonly role: string;
    readonly type: string;
    readonly profile: ProfileData;
    readonly company: CompanyData;
    readonly unverifiedEmail: string;
}

export enum USER_ROLE {
    DEFAULT = 'DEFAULT',
    ADMIN = 'ADMIN',
}

export enum USER_TYPE {
    INDIVIDUAL = 'INDIVIDUAL',
    PROFESSIONAL = 'PROFESSIONAL',
    SUPERADMIN = 'SUPERADMIN',
    OPERATEUR = 'OPERATEUR',
}

export enum USER_GENDER {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export enum COMPANY_TYPE {
    AUTOCARISTE = 'AUTOCARISTE',
    ASSOCIATION = 'ASSOCIATION',
    SERVICE_PUBLIC = 'SERVICE PUBLIC',
    ENTREPRISE = 'ENTREPRISE',
    EVENEMENT = 'EVENEMENT',
    AGENCE = 'AGENCE DE VOYAGE',
    AUTRE = 'AUTRE',
  }



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/users/profile.model.ts